import { render, staticRenderFns } from "./act-signup.vue?vue&type=template&id=7057615a&scoped=true"
import script from "./act-signup.vue?vue&type=script&lang=js"
export * from "./act-signup.vue?vue&type=script&lang=js"
import style0 from "./act-signup.vue?vue&type=style&index=0&id=7057615a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7057615a",
  null
  
)

export default component.exports